import React from 'react';
import TextAreaComponent from '../../../atoms/TextAreaComponent';
import ContentBox from '../../../molecules/ContentBox';
import EditorTextComponent from '../../../atoms/EditorTextComponent';




interface DescriptionProductProps {
    title?: string;
    content?: React.ReactNode;
}

const DescriptionProduct = ({ title, content }: DescriptionProductProps) => {
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // Títulos: h1, h2, sem cabeçalho
            ['bold', 'italic', 'underline', 'strike'], // Formatação de texto
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listas ordenadas e não ordenadas
            [{ 'script': 'sub' }, { 'script': 'super' }], // Subscrito e sobrescrito
            [{ 'indent': '-1' }, { 'indent': '+1' }], // Reduzir ou aumentar a indentação
            [{ 'size': ['small', false, 'large', 'huge'] }], // Tamanhos de fonte
            [{ 'color': [] }, { 'background': [] }], // Cor do texto e cor de fundo
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }], // Alinhamento
            [{ 'font': [] }], // Fontes disponíveis
            ['link', 'image', 'video'], // Inserir links, imagens e vídeos
            ['clean'], // Limpar formatação
            ['code-block'], // Bloco de código
        ],
    };

    return (
        <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Cadastro de Descrição" description='Tela para cadastro de Descrição'>
            <EditorTextComponent
                name="description"
                modules={modules} />
        </ContentBox>
    )
};

export default DescriptionProduct;
